import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { computed, action } from 'mobx'
import { withStyles } from 'material-ui/styles'
import SwipeableViews from 'react-swipeable-views'
import inject from 'helpers/inject'

import Paper from 'material-ui/Paper'
import AppBar from 'material-ui/AppBar'
import Tabs, { Tab } from 'material-ui/Tabs'
import LogInForm from 'components/LogInForm'
import RegistrationForm from 'components/RegistrationForm'

import AuthService from 'services/auth'
import RouterService from 'services/router'

import withAppStore from 'decorators/withAppStore'

import styles from 'styles/pages/auth'

@withStyles(styles)
@withAppStore
@observer
export default class extends Component {

  auth = inject(AuthService)
  router = inject(RouterService)

  @computed
  get tab() {
    switch (this.props.location.search) {
      case '?login': return 0
      case '?registration': return 1
      default: return 0
    }
  }

  componentWillMount() {
    if (this.auth.getIsAuthorized()) {
      this.router.transitionTo()
    }
    this.appStore.pageTitle = 'Авторизация'
  }

  render() {
    const { classes } = this.props

    return (
      <Paper elevation={1} className={ classes.paper } >
        <AppBar elevation={0} position="static" color="default">
          <Tabs
            value={ this.tab }
            onChange={ this.handleChange }
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="Вход" />
            <Tab label="Регистрация" />
          </Tabs>
        </AppBar>
        <SwipeableViews
          animateHeight
          index={ this.tab }
          onChangeIndex={ this.handleChangeIndex }
        >
          <LogInForm />
          <RegistrationForm />
        </SwipeableViews>
      </Paper>
    )
  }

  @action.bound
  handleChange(event, tab) {
    this.switchTab(tab)
  }

  @action.bound
  handleChangeIndex(index) {
    this.switchTab(index)
  }

  switchTab(index) {
    const { history, match } = this.props
    history.replace(`${match.path}?${index === 1 ? 'registration' : 'login'}`)
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth.js